/**
 * `router/home.js`
 *  - TOPページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {homeRouter} from "./router/home.js";
 */


export const homeRouter = () => {
  console.log("📖 Initializing home page...");
}